module.exports = __webpack_public_path__ + "static/media/sms-gray.27287a28.svg";